import { render, staticRenderFns } from "./MedicalPaymentsHistoryDetail.vue?vue&type=template&id=984098ea&scoped=true&"
import script from "./MedicalPaymentsHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./MedicalPaymentsHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPaymentsHistoryDetail.vue?vue&type=style&index=0&id=984098ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984098ea",
  null
  
)

export default component.exports